import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";

const initState = {
  reportTemplateID:""
};

export const addSetDataFormConfig = {
  name: "Report Template",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Client Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "reportTemplateID",
          label: "Report Template",
          Field_Name: "reportTemplate",
          fieldType: FormFieldTypes.SELECT,
          dataField: "reportTemplateID",
          fieldSetting: {
            placeholder: "Please select Report Template",
             allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 col-12",
          },
        }
      ],
    },
  ],
}